import { translate } from '../i18n'
import { NumericValidator } from './NumericValidator'

export class GTValidator extends NumericValidator {
    limit: number

    constructor(limit: number) {
        super()
        this.limit = limit
    }

    isValidNumber(value: number): boolean {
        return value > this.limit
    }
    getMessage = () =>
        translate('validations.gt', { number: this.limit }) as string
}
